import axios from "axios";
// import config from '../../../../config-front.json';
import store, {getConfig} from '../store/index';

const apiClient = axios.create({
    baseURL: 'https://your-api-url.com/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

export default {
    updateData(tableName, userId, params) {
        return apiClient.put(`/update/${tableName}/${userId}`, params);
    },
};

export async function axiosDB(params, data, callback = null) {
    try {
        const response = await axios.post(
            params?.url || getConfig().serverURL + '/server/requests/dbChangeAxio.php',
            {
                table: params.table,
                action: params.action,
                id: params.id,
                data: data
            }
        );

        await store.dispatch('fetchData');

        if (callback && typeof callback === 'function') {
            callback(response.data);
        }

        console.log('response', response)

        return response.data;
    } catch (error) {
        console.error('Error updating database:', error);

        // Если callback передан и является функцией, вызываем его с ошибкой
        // if (callback && typeof callback === 'function') {
        //     callback(error); // Передаем ошибку в callback
        // }

        throw error;
    }
}